import React from "react";
import { Navigate } from "react-router-dom";

const PermissionRoute = ({ children, permission }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const role = localStorage.getItem("user_role") || "";
  if (role === "super_admin") {
    return children;
  }

  if (!permission) {
    return children;
  }

  let permissions = [];
  try {
    permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch (error) {
    permissions = [];
  }

  return permissions.includes(permission) ? children : <Navigate to="/" />;
};

export default PermissionRoute;
